// extracted by mini-css-extract-plugin
export default {"background":"App_background__mV2gm","header":"App_header__r+QLE","dash":"App_dash__PM-Y7","footer":"App_footer__0ofNF"};